import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { useSelector, useDispatch } from 'react-redux';
import { SET_THERAPEUTIC_AREA_FILTERS } from '../../../actions/types';
import styles from './TherapeuticFilters.module.scss';

export default function TherapeuticFilters({
  close,
  isActive,
}) {
  const { filters } = useSelector((state) => state.therapeuticAreas);
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');

  function handleChangeFilters(key, value) {
    dispatch({
      type: SET_THERAPEUTIC_AREA_FILTERS,
      payload: {
        ...filters,
        [key]: value,
      },
    });
  }

  return (
    <div className={`${styles.container} ${isActive ? styles['is-active'] : ''}`}>
      <div className={styles.title}>
        <h2>Filtres</h2>
        <button
          onClick={() => close()}
          className={styles.close}>
          <IoMdClose size={30} />
        </button>
      </div>
      <div className={styles.filters}>
        <label>Recherche</label>
        <div className={styles.search}>
          <input
            value={search}
            placeholder={'Votre recherche'}
            onChange={(e) => setSearch(e.target.value)}
            />
          <button
            className={`${search ? styles['is-search'] : ''}`}
            onClick={() => handleChangeFilters('search', search)}
            >
            <IoSearch size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
